var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topbar" }, [
      _c("i", { on: { click: _vm.goHome } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox1" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _vm._v(
              "\r\n          " + _vm._s(_vm.$t("language")) + "\r\n          "
            ),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "changeLangBtn1",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("homepage_button1")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "forget" }, [
        _c("div", { staticClass: "forgetPsd" }, [
          _vm._v(_vm._s(_vm.$t("signin_txt3")))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "email" }, [
          _vm._v(_vm._s(_vm.$t("forPass_txt1")))
        ]),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "inputItem clearfix" }, [
              _c("span", { staticClass: "account" }, [
                _vm._v(_vm._s(_vm.$t("signin_txt1")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                attrs: { type: "text", dir: "ltr" },
                domProps: { value: _vm.email },
                on: {
                  blur: _vm.checkEmail,
                  focus: _vm.checkEmail1,
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.check($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.forgetShow
                ? _c(
                    "span",
                    {
                      staticClass: "s1",
                      domProps: { textContent: _vm._s(_vm.emailShowtext) }
                    },
                    [_vm._v(_vm._s(_vm.$t("signup_txt13")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "yanz", on: { click: _vm.check } }, [
                _vm._v(_vm._s(_vm.$t("forPass_txt3")))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        false
          ? _c(
              "div",
              {
                staticStyle: {
                  "font-size": "20px",
                  color: "#fff",
                  cursor: "pointer",
                  width: "500px",
                  margin: "0 auto",
                  height: "25px"
                }
              },
              [
                _c(
                  "label",
                  {
                    staticStyle: {
                      cursor: "pointer",
                      float: "left",
                      "margin-left": "76px",
                      "margin-top": "15px"
                    }
                  },
                  [
                    _c("input", {
                      staticStyle: {
                        width: "15px",
                        height: "15px",
                        display: "inline-block",
                        "margin-right": "5px"
                      },
                      attrs: {
                        name: "gender",
                        type: "radio",
                        value: "1",
                        checked: ""
                      },
                      on: { click: _vm.checkPone }
                    }),
                    _vm._v("手机号\r\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticStyle: {
                      cursor: "pointer",
                      float: "right",
                      "margin-right": "76px",
                      "margin-top": "15px"
                    }
                  },
                  [
                    _c("input", {
                      staticStyle: {
                        width: "15px",
                        height: "15px",
                        display: "inline-block",
                        "margin-right": "5px"
                      },
                      attrs: { name: "gender", type: "radio", value: "2" },
                      on: { click: _vm.checEmail }
                    }),
                    _vm._v("邮箱\r\n          ")
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "inputItem clearfix" }, [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("signin_txt1")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.phone,
                  expression: "phone"
                }
              ],
              attrs: { dir: "ltr", type: "text" },
              domProps: { value: _vm.phone },
              on: {
                blur: _vm.checkphone,
                focus: _vm.checkEmail1,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phone = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.forgetShow
              ? _c(
                  "span",
                  {
                    staticClass: "s1 s2",
                    domProps: { textContent: _vm._s(_vm.emailShowtext) }
                  },
                  [_vm._v(_vm._s(_vm.$t("signup_txt13")))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputItem clearfix" }, [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("signup_txt10")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.phoneCode,
                  expression: "phoneCode",
                  modifiers: { trim: true }
                }
              ],
              staticStyle: { "padding-right": "118px", width: "235px" },
              attrs: { type: "text", dir: "ltr" },
              domProps: { value: _vm.phoneCode },
              on: {
                blur: [
                  _vm.checkphoneCode,
                  function($event) {
                    _vm.$forceUpdate()
                  }
                ],
                focus: _vm.checkphoneCode1,
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.check11($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phoneCode = $event.target.value.trim()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { id: "buttonMsg" }, on: { click: _vm.getMsg } },
              [_vm._v(_vm._s(_vm.$t("signup_txt11")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show7,
                    expression: "show7"
                  }
                ],
                staticClass: "s1"
              },
              [_vm._v(_vm._s(_vm.$t("signup_note15")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "yanz", on: { click: _vm.check11 } }, [
              _vm._v(_vm._s(_vm.$t("forPass_txt3")))
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.checkeamilShow
          ? _c("div", { staticClass: "inputItem clearfix" }, [
              _c("span", { staticClass: "account" }, [_vm._v("邮箱")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.zhEmail,
                    expression: "zhEmail"
                  }
                ],
                attrs: { type: "text", dir: "ltr" },
                domProps: { value: _vm.zhEmail },
                on: {
                  blur: _vm.checkzhEmail,
                  focus: _vm.checkEmail1,
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key)
                    ) {
                      return null
                    }
                    _vm.check($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.zhEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.forgetShow
                ? _c(
                    "span",
                    {
                      staticClass: "s1",
                      domProps: { textContent: _vm._s(_vm.emailShowtext) }
                    },
                    [_vm._v(_vm._s(_vm.$t("signup_txt13")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "yanz", on: { click: _vm.check } }, [
                _vm._v(_vm._s(_vm.$t("forPass_txt3")))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.allMsg,
              expression: "allMsg"
            }
          ],
          staticClass: "send",
          domProps: { textContent: _vm._s(_vm.warinningText) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e9c0c3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9c0c3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgotPwd.vue
// module id = null
// module chunks = 